import Card from '../../components/SignUpV2/Layout/Card';
import AvatarCard from '../../components/AvatarCard';
import React from 'react';
import Grid from '@rezdy/components/Grid';
import TextStyle from '@rezdy/components/TextStyle';

export const TestimonialCard = () => {
    return (
        <Card photo="/img/signup-img.jpg">
            <Grid.Container rowGap>
                <Grid.Cell>
                    <TextStyle>
                        Rezdy saves us a significant amount of time which lets us focus on sailing, which is the main
                        thing for us.
                    </TextStyle>
                </Grid.Cell>
                <Grid.Cell>
                    <AvatarCard
                        avatar="/img/signup-avatar.jpg"
                        company="Owner, Manly Sailing"
                        name="Finn Irvine"
                        rating={6}
                    />
                </Grid.Cell>
            </Grid.Container>
        </Card>
    );
};
